import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RingLoader } from '../index';
import Cookies from 'universal-cookie';

const AdminRoute = ({ children }) => {
    const cookies = new Cookies();
    const tkn = cookies.get('tkn');
    const { userInfo, loading } = useSelector(state => state.userLogin);

    if (!tkn) return <Navigate to="/" />;
    if (loading || !userInfo.name) return <RingLoader />;
    if (!userInfo.isAdmin) return <Navigate to="/" />;

    return children;
};

export default AdminRoute;
